import React from "react";
import BAddPage from "../../../components/crud/BAddPage";
import { partnersService } from "../../../service/partnersService";
import { entities } from "../../../utilis/entitiesNames";

export default function PartnersAddPage() {
  return <BAddPage name={entities.PARTNERS} service={partnersService} />;
}
